// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__asK0w","active":"styles_active__tUZrU","top":"styles_top__auwHZ"};